import React, { useEffect, useState } from 'react'
import XMLViewer from 'react-xml-viewer'
import { makeStyles } from '@mui/styles'
import FileService from '@/modules/file/fileService'
import ThemeInterface from '@/theme-interface'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    display: 'flex',
    width: '100%',
    padding: '20px 40px',
    flexDirection: 'column',
    gap: 20,
  },
}))

interface DocumentDrawerPreviewXmlInterface {
  receiptUrl: string
  name: string
  data?: string // Pre-fetched data from parent component
  minioId?: string // If present, don't fetch using receiptUrl
}

export const DocumentDrawerPreviewXml = (props: DocumentDrawerPreviewXmlInterface) => {
  const { receiptUrl, data, minioId } = props
  const classes = useStyles()

  const [xmlString, setXmlString] = useState('')

  useEffect(() => {
    if (xmlString.startsWith('data')) {
      const base64String = xmlString.split(',')[1]
      setXmlString(Buffer.from(base64String, 'base64').toString('utf-8'))
      return
    }
  }, [xmlString])

  useEffect(() => {
    // Use pre-fetched data from parent if available
    if (data) {
      setXmlString(data)
      return
    }

    // If we have minioId, don't fetch using receiptUrl - wait for parent to provide data
    if (minioId) {
      return
    }

    // Fallback to URL-based fetching only when no minioId
    if (props.receiptUrl.includes('file')) {
      FileService.fetchFileDataByUrl(props.receiptUrl)
        .then(data => {
          setXmlString(data)
        })
    } else if (props.receiptUrl.startsWith('data')) {
      const base64String = props.receiptUrl.split(',')[1]
      setXmlString(Buffer.from(base64String, 'base64').toString('utf-8'))
    }
  }, [receiptUrl, data, minioId])

  return (
    <>
      <div className={classes.root}>
        <XMLViewer xml={xmlString} collapsible />
      </div>
    </>
  )
}

export default DocumentDrawerPreviewXml
